"use client";

import { smsUserLogin } from "@/01-core/user/user";
import { zodResolver } from "@hookform/resolvers/zod";
import { Button, Input, Modal, ModalBody, ModalContent, ModalHeader, useDisclosure } from "@nextui-org/react";
import { useRef, useState } from "react";
import { Loader2 } from "lucide-react";
import { Altcha } from "react-altcha";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { useAction } from "next-safe-action/hooks";
import { getSMSCode, bindphoneAction } from "./bind.action";
import { useToast } from "@/03-presenters/components/ui/use-toast";
import { useRouter } from "next/navigation";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/03-presenters/components/ui/select";
import Image from "next/image";
import { useBtnCountDown, useRefresh } from "@/03-presenters/shared/hooks";
import { LoadingOverlay } from "@mantine/core";
export default function BindPhone() {
  const [altchaKey, setAltchaKey] = useState(0);
  const {
    isReFreshing,
    refresh
  } = useRefresh();
  const {
    isOpen,
    onOpen,
    onOpenChange,
    onClose
  } = useDisclosure();
  const {
    toast
  } = useToast();
  const altchaForm = useRef<HTMLFormElement>(null);
  const submitAltchaForm = () => {
    altchaForm.current?.dispatchEvent(new Event("submit", {
      bubbles: true,
      cancelable: true
    }));
  };
  const {
    countDown,
    startCountDown,
    setStartCountDown
  } = useBtnCountDown(60);
  const {
    execute: getSMSCodeAction,
    isExecuting: gettingSMSCode
  } = useAction(getSMSCode, {
    // 每次获取验证码后，增加altchaKey，重新触发验证码
    onSettled: () => setAltchaKey(key => key + 1),
    onError: ({
      error
    }) => {
      if (error.validationErrors?.phoneNumber?._errors?.[0]) {
        setError("phoneNumber", {
          message: error.validationErrors.phoneNumber._errors[0],
          type: "value"
        });
      }
      if (error.serverError) {
        toast({
          title: "发送验证码失败",
          description: error.serverError,
          duration: 5000,
          variant: "destructive"
        });
        console.log("error.serverError", error.serverError);
      }
    },
    // 成功获取验证码后开始倒计时
    onSuccess: () => setStartCountDown(true)
  });
  const {
    execute: login,
    isExecuting: loginLoading
  } = useAction(bindphoneAction, {
    onError: ({
      error
    }) => {
      if (error.serverError) {
        toast({
          title: "绑定手机失败",
          description: error.serverError,
          duration: 5000,
          variant: "destructive"
        });
      }
    },
    onSuccess: () => {
      toast({
        title: "绑定手机成功",
        duration: 2000,
        variant: "default"
      });
      onClose();
      refresh();
    }
  });
  const {
    register,
    formState,
    handleSubmit,
    setFocus,
    trigger,
    setError,
    getFieldState,
    getValues
  } = useForm<z.infer<typeof smsUserLogin>>({
    resolver: zodResolver(smsUserLogin),
    mode: "onSubmit",
    reValidateMode: "onChange",
    defaultValues: {
      phoneNumber: "",
      smsCode: ""
    }
  });
  const smsBtnContent = () => {
    if (startCountDown) {
      return countDown + "s";
    } else {
      return <span className="inline-flex items-center px-4">
          获取验证码
          {gettingSMSCode && <Loader2 className="ml-2 size-4 animate-spin" />}
        </span>;
    }
  };
  return <>
      <div className="relative">
        <LoadingOverlay visible={isReFreshing} zIndex={11} overlayProps={{
        radius: "sm",
        blur: 2
      }} loaderProps={{
        size: 10
      }} data-sentry-element="LoadingOverlay" data-sentry-source-file="BindPhone.tsx" />
        <Button onClick={onOpen} data-sentry-element="Button" data-sentry-source-file="BindPhone.tsx">绑定手机</Button>
      </div>
      <Modal isOpen={isOpen} onOpenChange={onOpenChange} data-sentry-element="Modal" data-sentry-source-file="BindPhone.tsx">
        <ModalContent data-sentry-element="ModalContent" data-sentry-source-file="BindPhone.tsx">
          <ModalHeader data-sentry-element="ModalHeader" data-sentry-source-file="BindPhone.tsx">绑定手机</ModalHeader>
          <ModalBody data-sentry-element="ModalBody" data-sentry-source-file="BindPhone.tsx">
            <form onSubmit={handleSubmit(data => login(data))} className="flex flex-col gap-1">
              <Input {...register("phoneNumber", {
              required: true
            })} name="phoneNumber" isRequired placeholder="请输入手机号" variant="bordered" type="number" isClearable className="h-[74px]" size="lg" errorMessage={formState.errors.phoneNumber?.message} isInvalid={!!formState.errors.phoneNumber} classNames={{
              inputWrapper: "pl-0"
            }} startContent={<Select defaultValue="cn">
                    <SelectTrigger className="my-0.5 ml-0.5 h-full w-40 rounded-r-none border-0 border-r-1  focus:ring-0 focus:ring-offset-0">
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="cn">
                        <div className="flex flex-nowrap items-center gap-2">
                          <Image width={26} height={18} src="/login/cnflag.png" alt="cn flag" />
                          <div>+86</div>
                        </div>
                      </SelectItem>
                    </SelectContent>
                  </Select>} data-sentry-element="Input" data-sentry-source-file="BindPhone.tsx" />
              <Input {...register("smsCode", {
              required: true
            })} name="smsCode" isRequired variant="bordered" placeholder="请输入验证码" type="number" size="lg" className="h-[74px]" classNames={{
              inputWrapper: "pr-1"
            }} errorMessage={formState.errors.smsCode?.message} isInvalid={!!formState.errors.smsCode} endContent={<Button id="smslogin-btn" isDisabled={
            // 如果手机号码不合法或者正在倒计时或者正在获取验证码
            getFieldState("phoneNumber").invalid || startCountDown || gettingSMSCode} onClick={async () => {
              const isPhoneNumberValid = await trigger("phoneNumber", {
                shouldFocus: true
              });
              if (!isPhoneNumberValid) return;
              submitAltchaForm();
              setFocus("smsCode");
            }}>
                    {smsBtnContent()}
                  </Button>} data-sentry-element="Input" data-sentry-source-file="BindPhone.tsx" />
              <div className="mt-2 flex">
                <Button isDisabled={loginLoading} type="submit" fullWidth color="primary" data-sentry-element="Button" data-sentry-source-file="BindPhone.tsx">
                  确定
                  {loginLoading && <Loader2 className="ml-2 size-4 animate-spin" />}
                </Button>
              </div>
            </form>
            <form onSubmit={e => {
            e.preventDefault();
            getSMSCodeAction({
              phoneNumber: getValues("phoneNumber")
            });
          }} ref={altchaForm}>
              <Altcha
            // @ts-ignore
            strings={JSON.stringify({
              error: "抱歉，验证未通过，请再试一次",
              label: "我不是机器人",
              verified: "验证成功！",
              verifying: "验证中...",
              waitAlert: "验证中..."
            })} key={altchaKey}
            // @ts-ignore
            floating="auto"
            // challengeurl="https://eu.altcha.org/api/v1/challenge?apiKey=ckey_0179cbb35a3dea6816e8d4db8464"
            challengeurl="/api/login/captcha?lang=zh"
            // verifyurl="https://api-pre.service.aisale.tech/api/login/verify?lang=zh"
            floatinganchor="#smslogin-btn" hidelogo hidefooter data-sentry-element="Altcha" data-sentry-source-file="BindPhone.tsx" />
            </form>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>;
}